import { Container, CssBaseline, Grid, Typography } from '@mui/material';
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl';
import Api from "src/services/api";
import { connect } from 'react-redux';
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { AbilityContext } from '../../config/ability-context';
import * as componentActions from "../../redux/actions/users";
import { bindActionCreators } from "redux";
import { Styles } from 'src/styles/material-styles';

const footerStyle = {
    fontSize: "20px",
    color: "white",
    position: "fixed",
    textAlign: "center",
    left: "0",
    bottom: "0",
    height: "25px",
    width: "100%",
    zIndex: 0,
}

const footerStyleMobile = {
    fontSize: "20px",
    color: "white",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "25px",
    width: "100%",
    zIndex: 0,
}

const flex = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}

class FooterLogin extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showfooterusetermslink: Api != null ? Api.getShowFooterUseTermsLink() : true,
            matches: window.matchMedia("(max-width: 599px)").matches,
        }
    }

    async componentDidMount() {
        document.title = this.state.appName
        const handler = e => this.setState({ matches: e.matches })
        window.matchMedia("(max-width: 599px)").addListener(handler)
    }

    render() {
        const { classes, userSession, intl } = this.props
        const { showfooterusetermslink, matches } = this.state

        var version = process.env.REACT_APP_VERSION;
        if (version == null || version == "") {
            version = "1.0.0";
        }


        return (
            <div style={matches ? footerStyleMobile : footerStyle}>
                <Container component='main' maxWidth='xl'>
                    <CssBaseline />
                    <div className={classes.paper} style={{ marginTop: 0, paddingTop: 0, height: "25px" }}>
                        <Grid container xs style={{ paddingTop: 0, ...flex }}>
                            <Grid item style={{ paddingTop: 0, ...flex }}>
                                <Typography variant="h6" className={classes.title}>
                                    <div className={classes.title} style={{ paddingLeft: '30px', color: '#3e3c3c', fontSize: '11px' }}>
                                        {this.state.footerText} <FormattedMessage id="version" /> {version} - <FormattedMessage id="copyright" />
                                        <span >
                                            {this.state.showfooterusetermslink == true && <a style={{ marginLeft: '15px' }} href="https://dpo.privacytools.com.br/policy-view/nzVRBwDmQ/3/termos-e-condic%CC%A7o%CC%83es-gerais-de-uso-plataforma-mexx/pt_BR" target="_blank" rel="noreferrer"><FormattedMessage id="useterm" /></a>}
                                            {this.state.showfooterusetermslink == true && <a style={{ marginLeft: '15px' }} href="https://wiki.mexx.com.br/en/2-Mexx2DO/Administrativo/politica-de-privacidade" target="_blank" rel="noreferrer"><FormattedMessage id="privacy.policy" /></a>}
                                        </span>
                                    </div>
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </div>
        )
    }
}

FooterLogin.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    FooterLogin: state.FooterLogin,
    userSession: state.userSession,
    users: state.users,
    chatHubConnection: state.chatHubconnection
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(FooterLogin)));
FooterLogin.contextType = AbilityContext;